import { TextInputField, NumberInputField } from '@sainsburys-tech/luna-form'
import { useComponentContext } from '../../ComponentContext'
import { IInput } from '../../../../../types/ComponentTypes/Components'
import { useEffect, useState } from 'react'

function InputComponent({ label, id, info, error, placeholder, answer, defaultValue, prefix, inputType, disabled }: IInput) {
  const [value, setValue] = useState(answer ? answer : defaultValue || '')
  const { handleUpdate } = useComponentContext()
  const handleChange = (e: any) => {
    handleUpdate({ id, value: e.target.value })
    setValue(e.target.value)
  }

  useEffect(() => {
    if (value) {
      handleChange({ target: { value: value } });
    }
  }, [value]);

  if (inputType === "number"){
    return(
    <div>
      <NumberInputField
        name={id}
        label={label}
        info={info}
        error={error}
        placeholder={placeholder}
        onChange={handleChange}
        value={answer ?? value}
        icon={prefix!== "" ? <span>{prefix}</span>: null}
        disabled={disabled}

      />
    </div>)
  }

  return (

    <div>
      <TextInputField
        name={id}
        label={label}
        info={info}
        error={error}
        placeholder={placeholder}
        onChange={handleChange}
        value={answer ?? value}
        icon={prefix!== "" ? <span>{prefix}</span>: null}
        disabled={disabled}
      />
    </div>
  )
}

export default InputComponent
